import { useState, useEffect } from "react";
import "./training-location.css";

export default function TrainingLocation() {
  const [locationHistory, setLocationHistory] = useState(null);
  const [data, setData] = useState([
    {
      name: "Computer Systems Institute",
      city: "Chicago",
      address: "Willis Tower 233 S Wacker Dr, Chicago, IL 60606",
      contact: "+90 786786778",
    },
    {
      name: "Midwest Technical Institute",
      city: "Texas",
      address: "The Alamo 300 Alamo Plaza, San Antonio, TX 78205",
      contact: "+90 56778899",
    },
    {
      name: "Triton College Continuing Education",
      city: "California",
      address: "Golden Gate Bridge Golden Gate Bridge, San Francisco, CA 94129",
      contact: "+90 234455211",
    },
  ]);

  const hdata = [
    {
      name: "Computer Systems Institute",
      email: "ranji3344@mail.com",
      data: [
        {
          plan: "Tier 1",
          attend: 34,
          timing: "9.00am to 4.00pm",
          date: "01-05-2024",
          trainer: "James Patrick",
        },
        {
          plan: "Tier 2",
          attend: 20,
          date: "21-04-2024",
          timing: "9.00am to 4.00pm",
          trainer: "James Patrick",
        },
      ],
    },
  ];

  const [formValues, setFormValues] = useState({
    name: "",
    city: "",
    address: "",
    contact: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleEdit = (row) => {
    setFormValues(row);
    setIsEditing(true);
    enableForm(true);
  };

  const handleDelete = (name) => {
    setData(data.filter((item) => item.name !== name));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isEditing) {
      setData(
        data.map((item) => (item.name === formValues.name ? formValues : item))
      );
      setIsEditing(false);
    } else {
      setData([...data, { ...formValues }]);
    }
    setFormValues({ name: "", city: "", address: "", contact: "" });
    enableForm(false);
  };

  const [formBoolean, setFormBoolean] = useState(false);
  const [historyBoolean, setHistoryBoolean] = useState(false);

  const enableForm = (value) => {
    if (value === false) {
      setFormValues({ name: "", city: "", address: "", contact: "" });
    }
    setFormBoolean(value);
    setHistoryBoolean(false);
  };

  useEffect(() => {
    if (!formBoolean) {
      setFormValues({
        name: "",
        city: "",
        address: "",
        contact: "",
      });

      setIsEditing(false);
    }
  }, [formBoolean]);

  const enableHistory = (name, value) => {
    let userRecord = null;
    if (name != null) {
      userRecord = hdata.find((record) => record.name === name);
    }

    if (userRecord != null && userRecord !== undefined) {
      setLocationHistory(userRecord);
    } else {
      setLocationHistory(null);
    }

    if (value === true && userRecord) {
      setHistoryBoolean(value);
    } else if (value === false) {
      setHistoryBoolean(value);
      setLocationHistory(null);
    }
  };

  return (
    <div className="locations-parent-div">
      <h3 className="mt-3">Location Management</h3>
      {!formBoolean && !historyBoolean && (
        <div>
          <div className="location-new">
            <button className="resume-butn" onClick={() => enableForm(true)}>
              Add
            </button>
          </div>
          <div className="location-table-div mt-2">
            <table>
              <thead>
                <tr>
                  <th className="location-th-20"></th>
                  <th className="location-th">Location Name</th>
                  <th className="location-th">City</th>
                  <th className="location-th">Address</th>
                  <th className="location-th">Contact No</th>
                  <th className="location-th-50"></th>
                  <th className="location-th-50"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((location, index) => (
                  <tr key={index}>
                    <td className="location-th-20 cursor">
                      <svg
                        height="15"
                        width="15"
                        fill="#000000"
                        viewBox="0 0 512 512"
                        onClick={() => enableHistory(location.name, true)}
                      >
                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                      </svg>
                    </td>
                    <td className="location-td">{location.name}</td>
                    <td className="location-td">{location.city}</td>
                    <td className="location-td">{location.address}</td>
                    <td className="location-td">{location.contact}</td>
                    <td className="location-th-50 cursor">
                      <svg
                        width="15"
                        height="15"
                        fill="#000000"
                        viewBox="0 0 512 512"
                        onClick={() => handleEdit(location)}
                      >
                        <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
                      </svg>
                    </td>
                    <td className="location-th-50 cursor">
                      <svg
                        width="15"
                        height="15"
                        fill="#000000"
                        viewBox="0 0 448 512"
                        onClick={() => handleDelete(location.name)}
                      >
                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" />
                      </svg>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {formBoolean && (
        <div className="location-form-parent-div">
          <form onSubmit={handleFormSubmit}>
            <h5 className="mt-3">{isEditing ? "Edit" : "Add"} Location</h5>

            <div className="location-form-div mt-4">
              <div>
                <label htmlFor="">Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formValues.name}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label htmlFor="">City</label>
                <input
                  type="text"
                  name="city"
                  value={formValues.city}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label htmlFor="">Address</label>
                <input
                  type="text"
                  name="address"
                  value={formValues.address}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label htmlFor="">Contact</label>
                <input
                  type="text"
                  name="contact"
                  value={formValues.contact}
                  onChange={handleInputChange}
                />
              </div>
              <div className="location-buttons mt-4">
                <button
                  type="button"
                  className="resume-butn"
                  onClick={() => enableForm(false)}
                >
                  Cancel
                </button>
                <button className="resume-butn" type="submit">
                  {isEditing ? "Update" : "Add"} Location
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      {historyBoolean && (
        <div className="location-history-parent-div mt-4">
          <div className="history-header">
            <div
              className="history-close"
              onClick={() => enableHistory(null, false)}
            >
              X
            </div>
            <h5 className="">{locationHistory.name}'s Information</h5>
          </div>
          <div className="">
            <span>First Session Date : </span>
            <span>21-04-2024</span>
          </div>
          {locationHistory != null &&
            locationHistory.data.map((record, index) => (
              <div className="location-history-div mt-3" key={index}>
                <div>
                  <label htmlFor="">Plan</label>
                  <div>{record.plan}</div>
                </div>
                <div>
                  <label htmlFor="">People Attended</label>
                  <div className="text-center">{record.attend}</div>
                </div>
                <div>
                  <label htmlFor="">Date</label>
                  <div>{record.date}</div>
                </div>
                <div>
                  <label htmlFor="">Timing</label>
                  <div>{record.timing}</div>
                </div>
                <div>
                  <label htmlFor="">Trainer</label>
                  <div>{record.trainer}</div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
